import { Task, VisibleColumnSpec } from "@/types";

export const DEFAULT_TASK_COLUMNS: VisibleColumnSpec<Task, "actions" | "statusIcon" | "mobile-actions">[] = [
  { id: "statusIcon", breakpoint: "mantine-visible-from-sm" },
  "dueDate",
  "type",
  { id: "counterParty", breakpoint: "mantine-visible-from-md" },
  { id: "salesItem", breakpoint: "mantine-visible-from-md" },
  { id: "amount", breakpoint: "mantine-visible-from-md" },
  { id: "id", breakpoint: "mantine-visible-from-lg" },
  { id: "connected", breakpoint: "mantine-visible-from-lg" },
  "status",
  "actions",
  { id: "mobile-actions", breakpoint: "mantine-hidden-from-xs" },
];
